export type PlaceId =
  | 'town'
  | 'park'
  | 'house'
  | 'wardrobe'
  | 'cafe'
  | 'shop'
  | 'school'
  | 'pool'
  | 'stable'
  | 'garden-gate'
  | 'garden';

export type PlaceDef = {
  id: PlaceId;
  namePl: string;
  sceneKey: string;
  countsForExplorer: boolean;
};

export const PLACES: Record<PlaceId, PlaceDef> = {
  town: { id: 'town', namePl: 'Miasteczko', sceneKey: 'Town', countsForExplorer: true },
  park: { id: 'park', namePl: 'Park', sceneKey: 'Park', countsForExplorer: true },
  house: { id: 'house', namePl: 'Domek', sceneKey: 'House', countsForExplorer: true },
  wardrobe: { id: 'wardrobe', namePl: 'Salon Piękności', sceneKey: 'Wardrobe', countsForExplorer: true },
  cafe: { id: 'cafe', namePl: 'Kawiarnia „Kość"', sceneKey: 'Cafe', countsForExplorer: true },
  shop: { id: 'shop', namePl: 'Sklep z ubrankami', sceneKey: 'Shop', countsForExplorer: true },
  school: { id: 'school', namePl: 'Szkoła', sceneKey: 'School', countsForExplorer: true },
  pool: { id: 'pool', namePl: 'Basen', sceneKey: 'Pool', countsForExplorer: true },
  stable: { id: 'stable', namePl: 'Stajnia', sceneKey: 'Stable', countsForExplorer: true },
  'garden-gate': {
    id: 'garden-gate',
    namePl: 'Ogród marzeń (brama)',
    sceneKey: 'Garden',
    countsForExplorer: true,
  },
  garden: {
    id: 'garden',
    namePl: 'Ogród marzeń',
    sceneKey: 'Garden',
    countsForExplorer: false, // gate already counts
  },
};

export const EXPLORER_PLACE_IDS = (
  Object.values(PLACES).filter((p) => p.countsForExplorer).map((p) => p.id)
) as PlaceId[];

/** Logic size canvas. */
export const GAME_WIDTH = 1280;
export const GAME_HEIGHT = 720;
